import React, { useCallback, useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Switch } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DownloadIcon from "@mui/icons-material/Download";
import axiosInstance from "../../config/axios";
import { API_URLS } from "../../config/apiUrls";
import SearchAndSelect from "../../shared/SearchAndSelect";
import ImageGallery from "./ImageGallery";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const EnventryManagement = () => {
  // const superuserId = localStorage.getItem("is_superuser");
  const StoreID = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);

  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [mainCategoryData, setMainCAtegoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  // add start
  const [productName, setProductName] = useState("");
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState(null);
  const [BrandId, setBrandId] = useState(null);
  const [hsn, setHsn] = useState("");
  const [decription, setDecription] = useState("");
  const [image, setImage] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDecription, setMetaDecription] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [gst, setGst] = useState("");
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);

  // upload excel formate start
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [countData, setCountData] = useState({});
  const [searchParams, setSearchParams] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const [overview, setOverview] = useState("")
  const [overview1, setOverview1] = useState("")

  const [productId, setProductId] = useState(null)

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // upload excel formate end

  // add end
  const [searchQuery, setSearchQuery] = useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setRowData({});
    setIds(null);
    setProductName("");
    setHsn("");
    setDecription("");
    setMetaTitle("");
    setMetaDecription("");
    setMainCategoryId("");
    setSubCategoryId(null);
    setBrandId(null);
    setOpen(false);
    setOverview("")
    setOverview1("")
  };
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const submitCategory = () => {
    const fd = new FormData();
    ids !== null && fd.append("product_id", ids);
    fd.append("main_category", mainCategoryId);
    fd.append("sub_category", subCategoryId);
    fd.append("brand_name", BrandId);
    fd.append("title", productName);
    fd.append("image", image);
    fd.append("HSN", hsn);
    fd.append("Meta_Keyword", metaKeyword);
    fd.append("description", decription);
    fd.append("Meta_Title", metaTitle);
    fd.append("Meta_Description", metaDecription);
    fd.append("sgst", gst / 2);
    fd.append("cgst", gst / 2);
    fd.append("igst", gst);
    fd.append("overview1_image", overview)
    fd.append("overview2_image", overview1)

    ids === null
      ? axiosInstance
        .post(`${API_URLS.productApi}?store_id=${StoreID}`, fd)
        .then((response) => {
          if (response.data.response_code === 200) {
            toast.success(response.data.message);
            setRowData({});
            setIds(null);
            setProductName("");
            setHsn("");
            setDecription("");
            setMetaTitle("");
            setMetaDecription("");
            setMetaKeyword("");
            setGst("");
            inventoryData();
            handleClose();
            setOverview("")
            setOverview1("")
          }
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
        })
      : axiosInstance
        .put(`${API_URLS.productApi}?store_id=${StoreID}`, fd)
        .then((response) => {
          toast.success(response.data.message);
          setRowData({});
          setIds(null);
          setProductName("");
          setHsn("");
          setDecription("");
          setMetaTitle("");
          setMetaDecription("");
          setMetaKeyword("");
          setGst("");
          inventoryData();
          setOverview("")
          setOverview1("")
          handleClose();
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
        });
  };





  useEffect(() => {
    const mainCategoryList = () => {
      axiosInstance
        .get(`${API_URLS.category}`, {
          store_id: StoreID,
        })
        .then((response) => {
          setMainCAtegoryData(response?.data?.data);
        })
        .catch((error) => {
          console.log("", error);
        });
    };

    mainCategoryList();
  }, []);

  const subCategoryList = useCallback(
    (searchSubCategory) => {
      const fd = new FormData();
      fd.append(
        "main_category",
        ids === null ? mainCategoryId : rowData?.main_category
      );
      axiosInstance
        .get(
          `${API_URLS.subCategory}`,
          {
            params: {
              search: searchSubCategory,
              main_category: mainCategoryId,
            },
          },
          fd
        )
        .then((response) => {
          setSubCategoryData(response?.data?.data);
        })
        .catch((error) => {
          console.log("error page", error.response);
        });
    },
    [ids, mainCategoryId, rowData?.main_category]
  );

  useEffect(() => {
    if (mainCategoryId || rowData.length) {
      subCategoryList(searchSubCategory);
    }
  }, [mainCategoryId, rowData, searchSubCategory, subCategoryList]);

  useEffect(() => {
    const brandList = () => {
      axiosInstance
        .get(`${API_URLS.brandList}?search=${searchParams}`, {
          store_id: StoreID,
        })
        .then((response) => {
          setBrandData(response?.data?.data);
        })
        .catch((error) => {
          console.log("", error);
        });
    };

    brandList();
  }, [StoreID, rowData, searchParams]);

  const inventoryData = useCallback(() => {
    axiosInstance
      .get(
        `${API_URLS.productApi}?search=${searchQuery}&store_id=${StoreID}&page=${page}`
      )
      .then((response) => {
        console.log("Inventory Data List===>", response?.data?.data);
        setData(response?.data?.data);
        setCurrentPage(response.data.current_page);
        setTotalPage(response.data.total_pages);
      })
      .catch((error) => {
        console.log("", error);
      });
  }, [StoreID, page, searchQuery]);

  useEffect(() => {
    inventoryData();
  }, [searchQuery, page, inventoryData]);

  const EditFunction = (row) => {
    setRowData(row);
    setMainCategoryId(row?.main_category);
    setSubCategoryId(row?.sub_category);
    setBrandId(row?.brand_name);
    setIds(row?.id);
    setProductName(row?.title);
    setHsn(row?.HSN);
    setDecription(row?.description);
    setMetaTitle(row?.Meta_Title);
    setMetaDecription(row?.Meta_Description);
    setMetaKeyword(row?.Meta_Keyword);
    setGst(row?.igst);
    setSearchParams(row?.brand);

  };

  const hangleCancel = () => {
    handleClose();
  };

  const Enable = (id) => {
    axiosInstance
      .post(`api/admin/product-return-policy-enable-disable-admin/`, {
        product_id: id,
      })
      .then((response) => {
        toast.success(response?.data?.message);
        inventoryData();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };

  const ReEnabled = (id) => {
    axiosInstance
      .post(`api/admin/product-replacement-policy-enable-disable-admin/`, {
        product_id: id,
      })
      .then((response) => {
        toast.success(response?.data?.message);
        inventoryData();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };

  const deleteProduct = (event, id) => {
    event.preventDefault();
    const deleteData = window.confirm("are you sure delete this product...!");
    if (deleteData === true) {
      axiosInstance
        .delete(`${API_URLS.productApi}`, {
          data: { product_ids: [id], store_id: StoreID },
        })
        .then((response) => {
          toast.success(response.data.message);
          inventoryData();
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
        });
    }
  };

  const updaloadFile = () => {
    const formData = new FormData();
    formData.append("file", file);

    axiosInstance
      .post("api/admin/upload-product-by-excel-admin-api/", formData, {
        onUploadProgress: (progressEvent) => {
          const percentage = (progressEvent.loaded / progressEvent.total) * 100;
          setProgress(percentage);
        },
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success(response?.data?.message);
          setUploading(true);
          setProgress(100);
          setCountData(response?.data);
        } else {
          toast.warn(response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error?.message);
        toast.error(error.message);
      });
  };

  const handleModalClose1 = () => {
    setFile(null);
    setUploading(false);
    setProgress(0);
    inventoryData();
    handleClose1();
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(
        "https://app1.crazzyhub.com/api/admin/sample-format-upload-product-data-admin/",
        {
          method: "POST",
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "sample_product_data.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error:", error);
      toast.error("You have No Permission...!");
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };
  console.log("brandId", BrandId, searchParams);
  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Inventory (Product) Management
          </p>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex gap-3">
            <input
              class="placeholder:italic placeholder:text-slate-400 mx-3 block bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
              placeholder="Search for anything..."
              type="text"
              name="search"
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="mx-3 text-red-500">
              <Button
                variant="outlined"
                className="!mx-2"
                color="primary"
                onClick={handleOpen1}
              >
                <AddIcon />
                product upload by excel
              </Button>
              <Button variant="outlined" color="primary" onClick={handleOpen}>
                <AddIcon />
                Add Product
              </Button>

              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 750 }}
                  className="rounded-2xl !border-0 !h-[80vh] overflow-auto"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids === null ? "Add Product" : "Update Product"}
                  </div>
                  <div className="flex gap-x-3">
                    <div className="w-[50%]">
                      <div>Select Main Category :</div>
                      <FormControl fullWidth>
                        <Select
                          size="small"
                          name="main_category_id"
                          className="mt-1"
                          value={mainCategoryId}
                          onChange={(event) =>
                            setMainCategoryId(event.target.value)
                          }
                        >
                          {mainCategoryData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.category}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2">Select Sub Category :</div>
                      <FormControl fullWidth>
                        <SearchAndSelect
                          size="small"
                          className="mt-1"
                          name="sub_category_id"
                          textValue={searchSubCategory}
                          setTextValue={setSearchSubCategory}
                          value={subCategoryId}
                          setValue={(value) => setSubCategoryId(value)}
                          // onChange={setBrandId}
                          options={subCategoryData.map(
                            ({ id, subcategory }) => {
                              return {
                                label: subcategory,
                                value: id,
                              };
                            }
                          )}
                        />
                        {/* <Select
                          size="small"
                          className="mt-1"
                          name="sub_category_id"
                          value={subCategoryId}
                          onChange={(event) =>
                            setSubCategoryId(event.target.value)
                          }
                        >
                          {subCategoryData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.subcategory}
                            </MenuItem>
                          ))}
                        </Select> */}
                      </FormControl>
                      <div className="mt-2">Image :</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        type="file"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        onChange={(event) => setImage(event.target.files[0])}
                      />
                      <div className="flex justify-between w-full gap-x-2">
                        <div className="w-[50%]">
                          <div className="mt-2">GST :</div>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              className="mt-1"
                              name="gst"
                              value={"" || gst}
                              onChange={(event) => setGst(event.target.value)}
                            >
                              {[0, 5, 12, 18, 28]?.map((elem) => (
                                <MenuItem value={elem}>GST {elem} %</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="mt-2">Meta Keyword :</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        value={metaKeyword}
                        onChange={(event) => setMetaKeyword(event.target.value)}
                      />

                    </div>
                    <div className="w-[50%]">
                      <div className="">Select Brand Name :</div>
                      <SearchAndSelect
                        size="small"
                        className="mt-1"
                        name="brand"
                        textValue={searchParams}
                        setTextValue={setSearchParams}
                        value={Number(BrandId)}
                        setValue={(value) => setBrandId(value)}
                        // onChange={setBrandId}
                        options={brandData.map(({ id, brand_name }) => {
                          return {
                            label: brand_name,
                            value: id,
                          };
                        })}
                      />
                      {/* <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-1"
                          name="brand_name_id"
                          value={BrandId}
                          onChange={(event) => setBrandId(event.target.value)}
                        >
                          {brandData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.brand_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl> */}
                      <div className="mt-2">Product Name :</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        value={productName}
                        onChange={(event) => setProductName(event.target.value)}
                      />
                      <div className="mt-2">HSN :</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="hsn"
                        value={hsn}
                        onChange={(event) => setHsn(event.target.value)}
                      />
                      <div className="mt-2">Meta Title :</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        value={metaTitle}
                        onChange={(event) => setMetaTitle(event.target.value)}
                      />
                      <div className="mt-2">Meta Description :</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        value={metaDecription}
                        onChange={(event) =>
                          setMetaDecription(event.target.value)
                        }
                      />




                    </div>
                  </div>

                  <div className="mt-2">Product Description :</div>
                  <ReactQuill
                    className="w-full text-lg font-semibold bg-gray-100 border border-gray-700"
                    value={decription}
                    onChange={setDecription}
                  ></ReactQuill>

                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids === null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>

              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style1 }}
                  className="rounded-2xl !border-0 !h-[50vh] overflow-auto"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !pb-3 !text-center !text-xl"
                  >
                    Product Upload By Excel
                  </div>
                  <div
                    className="relative float-right px-2 font-bold text-black rounded-sm cursor-pointer bottom-16 bg-slate-300 left-6"
                    onClick={handleModalClose1}
                  >
                    x
                  </div>

                  <div className="flex gap-x-3 py-5 ">
                    <div className="font-bold text-gray-900">
                      Download Sample
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        className="!bg-blue-500"
                        size="small"
                        onClick={handleDownload}
                      >
                        Download <DownloadIcon />
                      </Button>
                    </div>
                  </div>
                  <div className="flex gap-x-3 py-2">
                    <TextField
                      size="small"
                      id="outlined-basic"
                      type="file"
                      className="!w-[100%] !mt-3"
                      onChange={handleFileChange}
                    />
                    <Button
                      onClick={updaloadFile}
                      disabled={uploading === true ? "" : uploading}
                      variant="contained"
                      type="submit"
                      color="success"
                      className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    >
                      {uploading ? "Uploaded" : "Upload"}
                    </Button>
                  </div>

                  {uploading && (
                    <div>
                      <progress value={progress} max="100" />
                      <span className="text-green-500 ">
                        {Math.round(progress)}%
                      </span>
                    </div>
                  )}
                  <br />
                  <table className="table w-full">
                    <thead>
                      <tr>
                        <th>Total Count</th>
                        <th>Create Count</th>
                        <th>Update Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center text-green-500">
                        <th>{countData?.total_data_count} </th>
                        <th>{countData?.created_data_count} </th>
                        <th>{countData?.updated_data_count} </th>
                      </tr>
                    </tbody>
                  </table>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%" }}
          className="!text-black !mx-auto !h-[70vh] !bg-white overflow-auto"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">BAR CODE</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">PRODUCT NAME</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">CATEGORY</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">SUB CATEGORY</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">BRAND</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>


                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  OverView Img
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IGST
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">Return Policy</div>
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36">Replacement Policy</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.bar_code ? row.bar_code : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.title ? row?.title : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.category ? row?.category : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.subcategory ? row?.subcategory : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.brand ? row?.brand : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img alt="" src={row.image} className="w-8 h-8" />
                      ) : (
                        "--"
                      )}
                    </TableCell>



                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <ImageGallery
                        isDelete={true}

                        // images={item.product_variant_image}
                        variantId={row.id}
                        // setResponse={setResponse}
                        // response={response}
                        setProductId={setProductId}
                        productId={productId}



                      />
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.sgst + " %"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.cgst + " %"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.igst + " %"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Switch
                        defaultChecked={row?.is_active_return}
                        onChange={(event) => Enable(row?.id)}
                      />
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Switch
                        defaultChecked={row?.is_active_replacement}
                        onChange={(event) => ReEnabled(row?.id)}
                      />
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <button onClick={handleOpen}>
                        <EditIcon
                          className="!text-xl !cursor-pointer !text-green-600"
                          onClick={() => EditFunction(row)}
                        />
                      </button>
                      <DeleteForeverIcon
                        onClick={(event) => deleteProduct(event, row?.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <hr />
          {totalPage !== 1 && (
            <div className="flex justify-center p-2">
              <Pagination
                page={currentPage}
                size="small"
                count={totalPage}
                variant="outlined"
                color="primary"
                onChange={handleChange}
              />
            </div>
          )}
        </TableContainer>
      </div>
    </div>
  );
};

export default EnventryManagement;
